import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import Star from "public/icons/ui/Star.svg";
import type { ResolvedReview } from "resolvers/data/trustpilotResolver";
import dayjs, { DateFormat } from "utils/dayjs";
import styles from "./ReviewCard.module.scss";

const cx = classNames.bind(styles);

const ReviewCard: React.FC<ResolvedReview & { prefetch?: boolean }> = ({
    quote,
    date,
    rating,
    href,
    prefetch = false,
}) => {
    return (
        <div className={cx("review")}>
            <div className={cx("textWrapper")}>
                <blockquote className={cx("quote")}>
                    {quote}
                    {quote.endsWith("...") ? (
                        <>
                            {" "}
                            <SmartLink href={href} prefetch={!!prefetch}>
                                <a className={cx("link")} target="_blank" rel="noopener noreferrer">
                                    [Read More]
                                </a>
                            </SmartLink>
                        </>
                    ) : null}
                </blockquote>
            </div>
            <div className={cx("details")}>
                <p className={cx("date")}>
                    Reviewed on:{" "}
                    <time dateTime={date}>
                        {dayjs(date).tz("Europe/London").format(DateFormat.WeekDayLong)}
                    </time>
                </p>
                <div className={cx("rating")}>
                    <div className={cx("stars")}>
                        {[...Array(5)].map((_, i) => (
                            <Star key={i} className={cx("star", { filled: i + 1 <= rating })} />
                        ))}
                    </div>
                    <p className={cx("ratingValue")}>({rating} out of 5)</p>
                </div>
            </div>
        </div>
    );
};

export default ReviewCard;
